// extracted by mini-css-extract-plugin
export default {"detail":"styles_detail__K8T+f","avatar":"styles_avatar__WYcUy","userName":"styles_userName__RXKNW"};